import { PaletteOptions, createTheme } from "@mui/material/styles";

export const darkTheme: PaletteOptions = {
  primary: {
    dark: "#100F15",
    main: "#17171c",
    light: "#2e2e33",
  },
  secondary: {
    dark: "#FFFFFF",
    main: "#F9F9F9",
    light: "rgb(0,0,0,0.1)",
  },
  text: {
    secondary: "#AAAABE",
  },
  success: {
    main: "#92FBB3",
  },
  error: {
    dark: "#D7273C",
    main: "#FF4F6E",
  },
  warning: {
    main: "#FF9F47",
  },
};
